import { useEffect, useState } from "react";
import { useLang } from "@/context/LangContext";
import { X, Globe } from "lucide-react";

const KEY = "negosino_lang_prompt_shown_v1";
const MESSAGES = {
  fr: "Bienvenue ! Votre navigateur est configuré en français. Ce site est disponible dans plusieurs langues.",
  en: "Welcome! Your browser is set to English. This site is available in multiple languages.",
  zh: "欢迎!您的浏览器语言为中文。本网站支持多语言。",
};
const CTA = { fr: "Continuer en français", en: "Continue in English", zh: "使用中文继续" };
const KEEP = { fr: "Rester", en: "Keep", zh: "保持" };

function detectBrowserLang() {
  const nav = (navigator.language || "").toLowerCase();
  if (nav.startsWith("zh")) return "zh";
  if (nav.startsWith("en")) return "en";
  if (nav.startsWith("fr")) return "fr";
  return null;
}

export default function LanguageWelcomeBanner() {
  const { lang, setLang } = useLang();
  const [suggest, setSuggest] = useState(null);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    const bl = detectBrowserLang();
    if (bl && bl !== lang) setSuggest(bl);
    else localStorage.setItem(KEY, "1");
  }, [lang]);

  if (!suggest) return null;

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setSuggest(null);
  };
  const accept = () => {
    setLang(suggest);
    localStorage.setItem(KEY, "1");
    setSuggest(null);
  };

  return (
    <div
      className="fixed bottom-6 left-6 z-50 max-w-md bg-[#0A0F1A] text-white rounded-xl shadow-2xl border border-white/10 p-5 pr-4 animate-fade-up"
      data-testid="lang-welcome-banner"
    >
      <div className="flex gap-4">
        <div className="w-10 h-10 rounded-full bg-[var(--accent)]/15 border border-[var(--accent)]/30 flex items-center justify-center shrink-0">
          <Globe size={18} className="text-[var(--accent)]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-white/90 leading-snug">{MESSAGES[suggest]}</p>
          <div className="mt-4 flex flex-wrap gap-2">
            <button
              onClick={accept}
              data-testid="lang-banner-accept"
              className="btn-primary !py-1.5 !px-3 text-xs"
            >
              {CTA[suggest]}
            </button>
            <button
              onClick={dismiss}
              data-testid="lang-banner-dismiss"
              className="text-xs px-3 py-1.5 rounded font-semibold text-white/60 hover:text-white transition-colors"
            >
              {KEEP[lang] || KEEP.fr}
            </button>
          </div>
        </div>
        <button
          onClick={dismiss}
          aria-label="close"
          data-testid="lang-banner-close"
          className="text-white/40 hover:text-white shrink-0"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
